import { Component } from '@angular/core';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(public baseService: BaseService) {
  }

  public readonly medias: any = [
    {
      icon: '/assets/img/media/telegram.svg',
      link: 'https://t.me/jecrm_info'
    },
    {
      icon: '/assets/img/media/instagram.svg',
      link: 'https://www.instagram.com/jecrm_/'
    },
    {
      icon: '/assets/img/media/youtube.svg',
      link: 'https://www.youtube.com/@JECRM-ORG'
    },
  ];
}
